let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("SiuII")).then(() => parcelRequire('5UanI'));